import { createRouter, createWebHistory } from 'vue-router';

// Enhanced dynamic import with error handling, retry mechanism, and chunk loading recovery
const safeImport = (importFn, retries = 3) => {
  return async () => {
    for (let i = 0; i < retries; i++) {
      try {
        const module = await importFn();
        return module;
      } catch (error) {
        const errorMessage = error.message || '';
        console.warn(`Module import attempt ${i + 1} failed:`, error);
        
        // Handle specific chunk loading errors
        if (errorMessage.includes('Loading chunk') || 
            errorMessage.includes('Failed to fetch dynamically imported module') ||
            errorMessage.includes('error loading dynamically imported module')) {
          
          // Clear module caches if available
          if (typeof window !== 'undefined' && window.__vitePreload) {
            delete window.__vitePreload;
          }
          
          // For chunk loading errors, try cache-busting reload
          if (i === retries - 1 && !window.routerRetryAttempted) {
            window.routerRetryAttempted = true;
            console.warn('Attempting cache-busted reload for chunk loading failure...');
            
            // Add cache busting parameter
            const url = new URL(window.location);
            url.searchParams.set('_cb', Date.now());
            window.location.href = url.toString();
            return;
          }
        }
        
        if (i === retries - 1) {
          console.error('All module import attempts failed:', error);
          // Return a fallback component or rethrow
          throw new Error(`Failed to load module after ${retries} attempts: ${errorMessage}`);
        }
        
        // Progressive delay with jitter to avoid thundering herd
        const delay = (100 * (i + 1)) + Math.random() * 100;
        await new Promise(resolve => setTimeout(resolve, delay));
      }
    }
  };
};
// import * as Sentry from "@sentry/vue";
// // import "@sentry/browser"; // Import from @sentry/browser
// import { BrowserTracing } from "@sentry/tracing"; // Ensure you import BrowserTracing

// Define your routes with enhanced error-safe dynamic imports using @ alias
const routes = [
  {
    path: '/',
    component: safeImport(() => import('@/layouts/BlankLayout.vue')),
    children: [
      { path: '', name: 'CheckOut', component: safeImport(() => import('@/pages/Checkout.vue')) },
      { path: 'thankYou', name: 'ThankYou', component: safeImport(() => import('@/pages/ThankYou.vue')) },
      { path: 'thankYouGrenke', name: 'ThankYouGrenke', component: safeImport(() => import('@/components/ThankyouGrenke.vue')) },
      { path: 'application-thank-you', name: 'ApplicationThankYou', component: safeImport(() => import('@/pages/ApplicationThankYou.vue')) },
      // Commented out routes with proper paths for future use
      // { path: 'verified', name: 'Verified', component: safeImport(() => import('@/pages/Verified.vue')) },
      // { path: 'external-link-verified', name: 'ExternalLinkVerified', component: safeImport(() => import('@/pages/ExternalLinkVerified.vue')) },
      // { path: 'confirm-verification', name: 'confirm-verification', component: safeImport(() => import('@/components/newcheckout/ConfirmVerification.vue')) },
    ]
  },
  {
    path: '/',
    component: safeImport(() => import('@/layouts/MainLayout.vue')),
    children: [
      // { path: 'verification', name: 'verification', component: safeImport(() => import('@/components/newcheckout/VerificationKYC.vue')) },
    ]
  },
  {
    path: '/nodatafound',
    name: 'PageNotFound',
    // component: safeImport(() => import('@/pages/Error404.vue'))
  }
];
// Create the router instance
const router = createRouter({
  history: createWebHistory(),
  routes,
});
// Sentry.init({
//   app,
//   dsn: "https://0ebb7ba9fef3471bbaa531795981589b@o4504873513385984.ingest.sentry.io/4504873560702976", // Replace with your DSN
//   integrations: [
//     new BrowserTracing({
//       tracingOrigins: ["localhost", /^https:\/\/yourserver\.io\/api/],
//     }),
//     Sentry.replayIntegration(),
//   ],
//   tracesSampleRate: 1.0,
//   replaysSessionSampleRate: 0.1,
//   replaysOnErrorSampleRate: 1.0,
// });
// Sentry initialization
// Sentry.init({
//   app,
//   dsn: "https://0ebb7ba9fef3471bbaa531795981589b@o4504873513385984.ingest.sentry.io/4504873560702976",
//   integrations: [
//     Sentry.browserTracingIntegration(), // Use the new import
//     Sentry.replayIntegration(),
//   ],
//   tracesSampleRate: 1.0,
//   tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
//   replaysSessionSampleRate: 0.1,
//   replaysOnErrorSampleRate: 1.0,
// });

export default router;